import { setActiveOrganization, setCredentials } from './slices';
import { baseApi } from './api/baseApi';
import { credentialsFromRefresh } from './api/reauthHelpers';
import { refreshSession } from '../services/cognito';
import type { AppDispatch } from './store';

/**
 * Capability: active organisation context switch.
 *
 * REST tenant scope is the Redux org (x-organization-id), not the JWT claim.
 * Switching must replace cached tenant data immediately so the previous org's
 * agents, roles, billing, and settings are never shown as the new org.
 */
export async function switchActiveOrganisation(
  dispatch: AppDispatch,
  nextOrgId: string,
  activate: (orgId: string) => Promise<unknown>
): Promise<void> {
  dispatch(setActiveOrganization(nextOrgId));
  dispatch(baseApi.util.resetApiState());
  try {
    await activate(nextOrgId);
  } catch {
    // Redux already holds the active org for x-organization-id.
  }
  try {
    const refreshed = await refreshSession({ force: true });
    if (refreshed) {
      dispatch(setCredentials(credentialsFromRefresh(refreshed, nextOrgId)));
    }
  } catch {
    // Cognito claim can lag; header org remains the source of truth.
  }
}
